module.exports = __webpack_public_path__ + "img/map_search_info_icon02.ceb93e75.svg";